<template>
  <transition name="fades">
    <div id="proctorBattleDialog" class="proctorBattleDialog" style="z-index: 2001" v-if="show" @mousewheel.prevent @scroll.stop.prevent>
      <div class="dialogBox">
        <div class="title bold">{{title}}</div>
        <div class="text" v-if="text">{{text}}</div>
        <div v-if="img" class="img">
          <img :src="img" alt="" srcset="">
        </div>
        <div v-if="yesTxt" class="btn">
          <div class="primary" @click="yesBtn">{{yesTxt}}</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'proctorBattleDialog',
  data () {
    return {
      show: false,
      title: '',
      text: '',
      yesTxt: '确定',
      confirm: null,
      img: ''
    }
  },
  computed: {},
  watch: {
    newShowHelp (val) {
      if (!val) {
        this.show = false
      }
    }
  },
  mounted () {},
  methods: {
    yesBtn () {
      this.confirm && this.confirm()
      this.show = false
    }
  }
}
</script>
<style lang="scss" scoped>
$width: 100vw/1920;
.proctorBattleDialog{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  .dialogBox{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    background: #FFFFFF;
    border-radius: 32*$width;
    border: 4*$width solid #001A61;
    text-align: center;
    min-width: 480*$width;
    max-width: 730*$width;
    padding: 40*$width;
    color: #1c1c1c;
    .title{
      font-size: 22*$width;
      line-height: 28*$width;
      font-weight: bold;
      // padding-bottom: 18*$width;
    }
    .text{
      font-size: 18*$width;
      line-height: 25*$width;
      margin-top: 16*$width;
      font-weight: 400;
      word-break: break-word;
      white-space: pre-wrap;
    }
    .img{
      margin-top: 18*$width;
      padding: 0 57*$width 0*$width;
      img{
        width: 550*$width;
      }
    }
    .btn{
      margin-top: 40*$width;
      .primary{
        cursor: pointer;
        width: 400*$width;
        height: 40*$width;
        border-radius: 20*$width;
        border: 2*$width solid #001a61;
        font-size: 16*$width;
        line-height: 40*$width;
        color: #FFFFFF;
        background: #3C65D6;
        box-shadow: inset 0*$width -5*$width 0*$width 0*$width #0044FF;
      }
    }
  }
}
body{
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/plugin/proctorBattleDialog/src/main.vue